import router from '@/router';
import SCookieBanner from '@/components/stemdo-components/s-cookie-banner/SCookieBanner.vue';

export default {
  components: { SCookieBanner },
  setup() {
    const goToLoginPage = () => {
      router.push('/login');
    };

    const goToCandidatesTypeForm = () => {
      window.location.href = 'https://wqe5865x2sl.typeform.com/to/Xsxf3xDD?typeform-source=platform.stemdo.io';
    };

    const goToSalesTypeForm = () => {
      window.location.href = 'https://wqe5865x2sl.typeform.com/to/T4lgGeky?typeform-source=www.stemdo.io';
    };

    return { goToLoginPage, goToCandidatesTypeForm, goToSalesTypeForm };
  }
};
